import { StatusCodes } from "http-status-codes";
import {
  IClaimRes,
  IClaimSubmissionResponse,
} from "../../../interfaces/IPreAuthClaim";
import Axios from "../../../utils/axiosInterceptor";
import { API_URL, PATIENT_APIS } from "../../../utils/constants";

export const fetchPortalDataStarHealth = async (caseId: number, visitId: number) => {
  try {
    const res = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_SERVICE}/cases/${caseId}/visitInfo/${visitId}/getAllCasePreAuthByCaseIdAndVisitId`
    );
    return res.data;
  } catch (error) {
    console.error("Failed to get portalData:", error);
    throw new Error("Failed to get portal data");
  }
};

export const getStarHealthReasonHospitalizationList = async (portalMetaDataId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/reasonForHospitalization/portalMetaDataId/${portalMetaDataId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get hospitalization reasons:", error);
    throw error;
  }
};

export const getStarHealthDocumentVerificationTypeList = async (portalMetaDataId: number, registrationId: string) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/documents/portalMetaDataId/${portalMetaDataId}/registrationId/${registrationId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get document verification types:", error);
    throw error;
  }
};

export const getStarHealthDiagnosisList = async (portalMetaDataId: number, hospitalId: number, schemeId: number, formData: any) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/portalDiagnosisData/portalMetaDataId/${portalMetaDataId}/hospitalId/${hospitalId}/schemeId/${schemeId}`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get diagnosis list:", error);
    throw error;
  }
};

export const getStarHealthChronicIllnessList = async (portalMetaDataId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/chronicIllness/portalMetaDataId/${portalMetaDataId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get chronic illness list:", error);
    throw error;
  }
};

export const getStarHealthProcedureList = async (portalMetaDataId: number, hospitalId: number, schemeId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/portalProcedureData/portalMetaDataId/${portalMetaDataId}/hospitalId/${hospitalId}/schemeId/${schemeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get procedure list:", error);
    throw error;
  }
};

export const getStarHealthSpecialityList = async (portalMetaDataId: number, hospitalId: number, schemeId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_SPECIALITY}/${portalMetaDataId}/schemeId/${schemeId}/hospitalId/${hospitalId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get speciality list:", error);
    throw error;
  }
};

export const getDoctorQualification = async () => {
  try {
    const response = await Axios.get(`${PATIENT_APIS.GET_QUALIFICATION}`);
    return response.data;
  } catch (error) {
    console.error("Failed to get doctor qualifications:", error);
    throw error;
  }
};

export const submitStarHealthPreAuth = async (caseId: number, visitInfoId: number, data: any) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.SAVE_PREAUTH_BY_CASE_ID}/${caseId}/visitInfo/${visitInfoId}/starhealth/casePreAuth`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Failed to submit preauth:", error);
    throw error;
  }
};

export const getPatientDetails = async (patientId: number) => {
  try {
    const response = await Axios.get(`${PATIENT_APIS.GET_PATIENT}/${patientId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to get patient details:", error);
    throw error;
  }
};

export const getCaseById = async (caseId: number) => {
  try {
    const response = await Axios.get(`${PATIENT_APIS.GET_CASE_BY_ID}/${caseId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to get case details:", error);
    throw error;
  }
};

export const getPreAuthById = async (casePreAuthId: number) => {
  try {
    const response = await Axios.get(`${PATIENT_APIS.GET_BY_PREAUTH_ID}/${casePreAuthId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to get preauth details:", error);
    throw error;
  }
};

export const getBillCategories = async (portalMetaDataId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/billCategories/portalMetaDataId/${portalMetaDataId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get bill categories:", error);
    throw error;
  }
};

export const deleteBillCategory = async (portalId: number, data: any) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.DELETE_PROCEDURE}/${portalId}/casePreAuthStarHealth_BillDetails`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Failed to delete bill category:", error);
    throw error;
  }
};

export const getBillSubCategories = async (billCatId: number, portalMetaDataId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_NEW_SERVICE}/sub-bill-Categories/portalMetaDataId/${portalMetaDataId}/billCategoryId/${billCatId}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get bill sub-categories:", error);
    throw error;
  }
};

export const submitIdStarHealth = async (caseId: number, visitId: number, schemeId: number, formData: any) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.SUBMIT_ID}/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Failed to submit ID:", error);
    throw error;
  }
};

export const registerPatientPortalStarHealth = async (portalMetaDataId: number, data: any) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.REGISTER_PORTAL_STARHEALTH}/${portalMetaDataId}/patientPortalRegistration`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error("Unable to do Portal Registration:", error);
   throw new Error(
      error?.response?.data || "Unable to do Portal Registration"
    );
  }
};

export const saveDraftStarhealth = async (
  caseId: number,
  visitId: number,
  payload: any
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.STARHEALTH_SERVICE}/cases/${caseId}/visitInfo/${visitId}/casePreAuth`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot save Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot save Pre Auth details");
  }
};


export const getStarHealthDocuments = async (caseId: number,
  visitId: number,
  payload: any) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.STARHEALTH_SERVICE}/cases/${caseId}/visitInfo/${visitId}/getAllDocuments`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDraftStarhealth = async (
  caseId: number,
  visitId: number,
  preAuthId: number,
  payload: any
) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.STARHEALTH_SERVICE}/cases/${caseId}/visitInfo/${visitId}/casePreAuthId/${preAuthId}`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot update Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot update Pre Auth details");
  }
};

export const fetchPreAuthToPortalStarhealth = async (
  caseId: number,
  visitId: number,
  payload: any
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.PREAUTH_DATA}/api/star-health/cases/${caseId}/visitInfo/${visitId}/initiateCasePreAuth`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot post Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post Pre Auth details");
  }
};

export const getPreAuthClaimStarhealth = async (caseId: number, visitId: number) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitId}/caseClaimSubmission`
    );

    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot get claim details",
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot get claim details:", error);
    throw new Error(
      error?.response?.data?.message || "Please, Try again later"
    );
  }
};

export const submitClaimSubmissionStarhealth = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    if (caseClaimId === null) {
      response = await Axios.post(
        `${PATIENT_APIS.STARHEALTH_SERVICE}/${caseId}/visit/${visitId}/claim/Starhealth`,
        data
      );
    } else {
      response = await Axios.patch(
        `${PATIENT_APIS.STARHEALTH_SERVICE}/${caseId}/visit/${visitId}/claim/Starhealth/${caseClaimId}`,
        data
      );
    }

    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot submit claim details",
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot submit claim details:", error?.response?.data);
    throw new Error(
      error?.response?.data?.message || "Cannot submit claim details"
    );
  }
}

export const intimateClaimStarhealth = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    const baseUrl = `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimIntimate`;
      response = await Axios.post(
        `${baseUrl}`,
        data
      );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot intimate claim details:", error);
    throw new Error("Cannot intimate claim details");
  }
};

export const postPreAuthClaimToEdgeProStarhealth = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    const baseUrl = `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData`;
    if (caseClaimId === null) {
      // POST request
      response = await Axios.post(
        `${baseUrl}/${portalId}/createCaseClaim`,
        data
      );
    } else {
      response = await Axios.patch(
        `${baseUrl}/${portalId}/caseClaim/${caseClaimId}/createCaseClaim`,
        data
      );
    }
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot post claim details:", error);
    throw new Error("Cannot post claim details");
  }
};

export const postPreAuthClaimStarhealth = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number
): Promise<IClaimSubmissionResponse> => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimSubmission`,
      data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const submitApprovalStarhealth = async (formData: any) => {
  try {
    const res = await Axios.post(`${PATIENT_APIS.APPROVE_PREAUTH}/star-health/approve`, formData);
    return res.data;
  } catch (error) {
    throw new Error("Failed to Approve");
  }
};

export const dischargeServiceStarhealth = {
  getDischargeData: async (caseId: number | undefined, visitId: number | undefined) => {
    try {
      const response = await Axios.get(
        `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitId}/caseDischarges`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching discharge data:", error);
      throw error;
    }
  },

 saveDischargeData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalId: number | undefined,
    caseDischargeId: number | null,
    payload: any
  ): Promise<void> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;

      if (caseDischargeId === null) {
        // POST request
        response = await Axios.post(
          `${baseUrl}/${portalId}/caseDischarges`,
          payload
        );
      } else {
        // PATCH request
        response = await Axios.patch(
          `${baseUrl}/${portalId}/caseDischarge/${caseDischargeId}/caseDischarges`,
          payload
        );
      }

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save discharge data");
      }
    } catch (error) {
      console.error("Error saving discharge data:", error);
      throw error;
    }
  },
  saveDischargeDataInEdgePro: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalId: number | undefined,
    caseDischargeId: number | null,
    payload: any
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;
      // POST request
      if (caseDischargeId === null) {
        response = await Axios.post(
          `${baseUrl}/${portalId}/createCaseDischarge`,
          payload
        );
      } else {
        response = await Axios.patch(
          `${baseUrl}/${portalId}/caseDischarge/${caseDischargeId}/createCaseDischarge`,
          payload
        );
      }

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }

      return response;
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },

  saveIntimateDischarge: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number | undefined,
    payload: any
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.STARHEALTH_SERVICE}/casesNew/${caseId}/visitInfo/${visitInfoId}/portalMetaData/${portalMetaDataId}/createCaseDischargeIntimation`;
      // POST request

      response = await Axios.post(`${baseUrl}`, payload);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save intimate discharge data");
      }
      return response;
    } catch (error) {
      console.error("Error saving intimate discharge data:", error);
      // throw error;
      throw new Error("Failed to save intimate discharge data");
    }
  },
  updateClaimId: async (
    formData: any,
    caseId: number | undefined,
    visitId: number | undefined,
    schemeId: number | undefined
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${API_URL}/api/cases/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`;

      response = await Axios.patch(`${baseUrl}`, formData);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to update claim Id ");
      }
      return response;
    } catch (error) {
      console.error("Failed to update claim Id:", error);
      // throw error;
      throw new Error("Failed to update claim Id");
    }
  },
}; 
